import { Micro as VdsMicro, MicroProps } from "@vds/typography";

const Micro = ({ children, ...rest }: MicroProps) => {
  return <VdsMicro {...rest}>{children}</VdsMicro>;
};

export default Micro;
